module.exports = __webpack_public_path__ + "img/Omar.9060ca65.png";